import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import SetCharacterPartsPreviewBody from "./SetCharacterPartsPreviewBody";

export default function SetCharacterPartsPreview() {
  return (
    <PiPopupWindowPreview
      header={<PiPopupHeaderBar interactionType={InteractionType.SetCharacterParts} title="Set Character Parts" />}
      body={<SetCharacterPartsPreviewBody />}
      size="large"
    />
  );
}
